document.addEventListener('DOMContentLoaded', function () {
    const loadMoreButton = document.getElementById('load-more-2');

    if (loadMoreButton) {
        loadMoreButton.addEventListener('click', function (e) {
            e.preventDefault();

            const page = parseInt(loadMoreButton.getAttribute('data-page'));
            const catId = loadMoreButton.getAttribute('data-cat');
            const ajaxUrl = ajax_params.ajax_url;

            loadMoreButton.disabled = true;

            fetch(ajaxUrl, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded',
                },
                body: new URLSearchParams({
                    'action': 'load_more_experience_posts_2',
                    'page': page,
                    'cat_id': catId
                })
            })
                .then(response => response.text())
                .then(data => {
                    if (data.trim()) {
                        document.getElementById('experience-list-2').insertAdjacentHTML('beforeend', data);

                        loadMoreButton.setAttribute('data-page', page + 1);

                        loadMoreButton.disabled = false;
                    } else {
                        loadMoreButton.style.display = 'none';
                    }
                })
                .catch(error => console.error('Помилка завантаження додаткових постів:', error));
        });
    }
});